import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";

export const fetchShowCase = createAsyncThunk(
  "case/showCase",
  async (id, { rejectWithValue }) => {
    
    try {
      const response = await api.get(`/cases/${id}`);
        console.log(response)
      return response.data.data;
    } catch (error) {
      console.error("API Error:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const showCaseSlice = createSlice({
  name: "showCase",
  initialState: {
    loading: false,
    error: null,
    case: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchShowCase.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchShowCase.fulfilled, (state, action) => {
        state.loading = false;
        state.case = action.payload;
      })
      .addCase(fetchShowCase.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default showCaseSlice.reducer;
